import axios from "axios";
import { oktaAuth } from "../context/AuthProvider";
import { getEnvValue } from "./getEnvValue";

const BASE_URL = getEnvValue("BACKEND_URL", '');

export const axiosInstance = axios.create({
  adapter: "fetch",
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    if (config.requiresToken !== false) {
      const token = await oktaAuth.getOrRenewAccessToken();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  async (error) => {
    return Promise.reject(error.response ?? error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error.response ?? error);
  },
);
